import { retryCancelablePromise } from '../core/utils/retryCancelablePromise';
export class SubscriptionService {
    constructor(httpRequest) {
        Object.defineProperty(this, "httpRequest", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: httpRequest
        });
    }
    /**
     * Get subscription
     * @returns SubscriptionList Ok.
     * @throws ApiError
     */
    getSubscription({ orgId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/subscription', path: {
                'orgId': orgId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Get organization subscriptions statuses
     * @returns SubscriptionStatusList Ok.
     * @throws ApiError
     */
    listSubscriptionsStatuses({ orgId, filter, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/orgs/{orgId}/subscription-status', path: {
                'orgId': orgId,
            }, query: {
                'filter': filter,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                402: `Payment Required.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Accept Rebilly webhook
     * @returns any Successful operation. The subscription is valid.
     * @throws ApiError
     */
    subscriptionWebhook(options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'GET', url: '/subscription/webhook', errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
    /**
     * Sync subscription data
     * Support-only endpoint to queue subscription data synchronization including seats and projects usage.
     * @returns any Sync completed successfully.
     * @throws ApiError
     */
    syncSubscription({ orgId, }, options) {
        return retryCancelablePromise(() => this.httpRequest.request(Object.assign({ method: 'POST', url: '/orgs/{orgId}/subscription-sync', path: {
                'orgId': orgId,
            }, errors: {
                400: `Bad Request.`,
                401: `User is not authorized to access this resource.`,
                403: `Forbidden.`,
                500: `Internal Server Error.`,
            } }, options)), options);
    }
}
//# sourceMappingURL=SubscriptionService.js.map